import { unsafeCSS, html } from "lit";
import { LeafElement } from "../leaf-element.js";
import { SlotController } from "../../utilities/slot.js";
import "../../utilities/events.js";
const styles = "/*------------------------------------*\\\n#BREADCRUMBS\n\\*------------------------------------*/\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host(:empty) {\n  display: none;\n}\n\n@media (max-width: 47.999rem) {\n  :host ::slotted(leaf-breadcrumbs-item:not([mobile-breadcrumb])) {\n    display: none;\n  }\n}\n\n.leaf-c-breadcrumbs__list {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: var(--leaf-spacing-4) 0;\n  margin: var(--leaf-spacing-8) 0;\n}";
class LeafBreadcrumbs extends LeafElement {
  constructor() {
    super(...arguments);
    this.slotController = new SlotController(this);
  }
  render() {
    return html`${this.slotController.hasDefaultSlot() ? html` <nav class="leaf-c-breadcrumbs" role="list" aria-label="breadcrumbs">
          <div class="leaf-c-breadcrumbs__list">
            <slot></slot>
          </div>
        </nav>` : ""}`;
  }
}
LeafBreadcrumbs.styles = unsafeCSS(styles);
export {
  LeafBreadcrumbs
};
//# sourceMappingURL=breadcrumbs.component.js.map
